import { render, staticRenderFns } from "./ProjectPolicyViolations.vue?vue&type=template&id=f50c47f4&"
import script from "./ProjectPolicyViolations.vue?vue&type=script&lang=js&"
export * from "./ProjectPolicyViolations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports